import { shuffle } from "lodash";
require("./style.scss");
require("iframe-resizer/js/iframeResizer.contentWindow.js");

// Get all the images and put them into things
const requireFacesContext = require.context(
   "../assets/oneadi",
   true,
   /\.(png|jpg|jpeg|gif)$/
);
const requirePpContext = require.context(
   "../assets/pp",
   true,
   /\.(png|jpg|jpeg|gif)$/
);
const requireMiscContext = require.context(
   "../assets/misc",
   true,
   /\.(png|jpg|jpeg|gif)$/
);

function importAll(r) {
   return r.keys().map(r);
 }

const facesList = importAll(requireFacesContext);
const ppList = importAll(requirePpContext);
const miscList = importAll(requireMiscContext);

// Get the templates
const imagesTemplate = require("./template.html");
const imagesContainer = document.createElement("div");

// // EVERYONE!!
// rows = 12;
// columns = 17;

// URL Params
const rows = parseInt(getQueryStringValue("rows"))
   ? parseInt(getQueryStringValue("rows"))
   : 2;
const columns = parseInt(getQueryStringValue("columns"))
   ? parseInt(getQueryStringValue("columns"))
   : 5;
const updateSeconds = parseInt(getQueryStringValue("seconds"))
   ? parseInt(getQueryStringValue("seconds"))
   : 30;
const whatAreweDoing = getQueryStringValue("slideshow")
   ? getQueryStringValue("slideshow").split(",")
   : ["faces"];
const autoUpdate = getQueryStringValue("autoUpdate")
   ? getQueryStringValue("autoUpdate")
   : false;

let shuffledFaces = shuffle(facesList);
let shuffledPp = shuffle(ppList);
let shuffledMisc = shuffle(miscList);

// get query strings in old browsers
function getQueryStringValue(key) {
   return decodeURIComponent(
      window.location.search.replace(
         new RegExp(
            "^(?:.*[&\\?]" +
               encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
               "(?:\\=([^&]*))?)?.*$",
            "i"
         ),
         "$1"
      )
   );
}

// cycles faces and displays them in a grid
function cycleFaces(rows, columns) {
   let faces = {
      row: []
   };

   let total = rows * columns;

   if (shuffledFaces.length < total) shuffledFaces = shuffle(facesList);

   for (let i = 0; i < rows; i++) {
      faces.row[i] = [];
      for (let j = 0; j < columns; j++) {
         let coolPerson = shuffledFaces.pop();
         if (coolPerson) faces.row[i].push(coolPerson);
      }
   }

   let widthPercent = 100 / columns;
   imagesContainer.innerHTML = imagesTemplate({
      widthPercent: widthPercent,
      faces: faces
   });
}

// cycles an array of images and displays them fullscreen
function cycleImages(array, index) {
   let faces = {
      row: [[array[index]]]
   };

   imagesContainer.innerHTML = imagesTemplate({
      widthPercent: 100,
      faces: faces
   });
}

// lets us know if we're doing something
function we_are_doing(item) {
   return whatAreweDoing.indexOf(item) >= 0;
}

// update the images on the page with whichever thing we're on
function updatePage(what_thing_are_we_on) {
   let we_are_on_faces = 0;
   let we_are_on_pp = 1;
   let we_are_on_misc = 2;

   if (what_thing_are_we_on == we_are_on_faces) {
      if (autoUpdate) {
         location.reload();
      } else {
         cycleFaces(rows, columns);
      }
   } else if (we_are_doing("pp") && what_thing_are_we_on == we_are_on_pp) {
      if (ppIndex + 1 >= ppList.length) ppIndex = -1;
      cycleImages(shuffledPp, ++ppIndex);
   } else if (we_are_doing("misc") && what_thing_are_we_on == we_are_on_misc) {
      if (miscIndex + 1 >= miscList.length) miscIndex = -1;
      cycleImages(shuffledMisc, ++miscIndex);
   }
}

document.body.appendChild(imagesContainer);

// start with faces
cycleFaces(rows, columns);

let ppIndex = 0;
let miscIndex = 0;

let slideshowIndex = 1;

// alternate between the things
setInterval(function() {
   if (slideshowIndex == whatAreweDoing.length) slideshowIndex = 0;
   updatePage(slideshowIndex++);
}, updateSeconds * 1000);
